import CreateAgent from "components/ManageAgent/CreateAgent";
import NotFooterLayout from "layouts/NotFooterLayout";

function CreateAgentPage() {
  return (
    <>   
      <NotFooterLayout namePage="เพิ่มลูกค้า"  >
        <div className="layout-content">
          <CreateAgent />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default CreateAgentPage;
